/**
 * Scopes storefront search to the browsable tag so Shopify filters before paginating.
 * Without this the theme filters after Shopify has already picked the first page,
 * which leaves search pages empty. Driven by Theme settings > Browse visibility.
 */
(function () {
  const tag = window.__browseScopeTag;
  if (!tag) return;

  const scope = ' AND tag:' + tag;
  const scoped = (q) => (!q || q.indexOf('tag:' + tag) !== -1 || q.indexOf('id:') !== -1 ? q : q + scope);

  // Search forms: scope the query on the way out.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if ((form.getAttribute('action') || '').indexOf('/search') === -1) return;
      const input = form.querySelector('input[name="q"]');
      if (input) input.value = scoped(input.value);
    },
    true
  );

  // Predictive search and section renders fetch their own URLs.
  const original = window.fetch;
  window.fetch = function (input, init) {
    try {
      const href = typeof input === 'string' ? input : input && input.url;
      if (href && /\/search(\/suggest)?/.test(href) && href.indexOf('q=') !== -1) {
        const url = new URL(href, location.origin);
        const q = url.searchParams.get('q');
        const next = scoped(q);
        if (next !== q) {
          url.searchParams.set('q', next);
          input = typeof input === 'string' ? url.toString() : new Request(url.toString(), input);
        }
      }
    } catch (error) {
      /* leave the request untouched */
    }
    return original.call(this, input, init);
  };
})();
